<app-header *ngIf="shouldDisplayHeader" id="app-header"></app-header>
<div
  class="app"
  [ngClass]="{
    'iframe-app': inIframe,
    'app': !inIframe,
    'loan-calculator-app': !inIframe && !shouldDisplayHeader
  }"
>
  <div class="body">
    <div *ngIf="navigating">
      <app-spinner></app-spinner>
    </div>
    <div [hidden]="navigating">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer
    *ngIf="!navigating"
    id="app-footer"
    [shouldDisplayLocaleSelector]="shouldDisplayLocaleSelector"
    [shouldDisplayDisclaimer]="shouldDisplayDisclaimer"
  ></app-footer>
</div>
